module.exports = __webpack_public_path__ + "static/media/typea.aa236006.jpg";